<template>
  <div>
    <section class="content">
      <!-- <div class="box no-border">
        <div class="box-body">
          <div class="col-md-6">
            <div class="row" style="margin-right:0px;margin-bottom:5px;">              
              <div class="col-sm-9 col-md-9 has-feedback">
                <div class="row">
                  <input type="text" class="form-control" v-on:keyup.enter="onSearch($event)" placeholder="Search by report name">
                  <span class="icon ion-search form-control-feedback"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="nav-tabs-custom">
        <ul class="nav nav-tabs">
          <li v-bind:class="{ active: tabActive == TAB_TICKETING }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Tikecting and POS</a></li>
          <li v-bind:class="{ active: tabActive == TAB_MEMBERSHIP }"><a href="#tab_2" data-toggle="tab" aria-expanded="false">Membership</a></li>
          <li v-bind:class="{ active: tabActive == TAB_LOYALTY }"><a href="#tab_3" data-toggle="tab" aria-expanded="false">Loyalty</a></li>
        </ul>
      </div>

      <div class="tab-content">
        <div v-bind:class="{ active: tabActive == TAB_TICKETING }" class="tab-pane" id="tab_1">
          <div class="box no-border">
            <div class="col-md-4" v-on:click="onReport">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Penjualan Online</h3>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <blockquote>
                    <p>Detail data penjualan tiket berdasarkan project </p>
                    <p>dan tanggal pembelian serta tanggal booking / proses date</p>
                  </blockquote>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- /.box -->
            </div>
            <div class="col-md-4" v-on:click="onRevenueReport">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Penerimaan</h3>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <blockquote>
                    <p>Detail data penerimaan berdasarkan project </p>
                    <p>dan tanggal pembelian </p>
                  </blockquote>
                </div>
                <!-- /.box-body -->
              </div>
            </div>
            <div class="col-md-4" v-on:click="onReportSalesPOS">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Penjualan via POS</h3>
                </div>
                <div class="box-body">
                  <blockquote>
                    <p>Laporan penjualan khusus untuk transaksi yg dihasilkan dari system POS (Point of Sales)</p>
                  </blockquote>
                </div>
              </div>
            </div>

            <div class="col-md-4" v-on:click="onReportSalesPOSNet">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Penjualan via POS (Net Amount)</h3>
                </div>
                <div class="box-body">
                  <blockquote>
                    <p>Laporan penjualan khusus untuk transaksi yg dihasilkan dari system POS (Point of Sales)</p>
                    <p>per Invoice dan net amount</p>
                  </blockquote>
                </div>
              </div>
            </div>

            <div class="col-md-4" v-on:click="onReportGoodsMovement">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Stock Barang</h3>
                </div>
                <div class="box-body">
                  <blockquote>
                    <p>Laporan pergerakan stock barang</p>
                  </blockquote>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-on:click="onReportProductSoldList">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Product Sold List</h3>
                </div>
                <div class="box-body">
                  <blockquote>
                    <p>Laporan Daftar penjualan bedasarkan kategori dan user secara realtime yg datanya diambil dari POS</p>
                    <p>Berdasarkan parameter tanggal transaksi dan kategori di POS</p>
                  </blockquote>
                </div>
              </div>
            </div>  

            <div class="col-md-4" v-on:click="onReportProductSoldSUmmary">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Summary Penjualan</h3>
                </div>
                <div class="box-body">
                  <blockquote>
                    <p>Laporan summary penjualan secara realtime yg datanya diambil dari POS</p>
                    <p>Berdasarkan parameter tanggal transaksi di POS</p>
                  </blockquote>
                </div>
              </div>
            </div>            
          </div>
        </div>
        <div v-bind:class="{ active: tabActive == TAB_MEMBERSHIP }" class="tab-pane" id="tab_2">
          <div class="box no-border">
            <div class="col-md-4" v-on:click="onReportMembershipTypeSummary">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Membership Type and Status Analysis</h3>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <blockquote>
                    <p>Menampilkan total membership per membership type dan status</p>
                  </blockquote>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- /.box -->
            </div>            
            <div class="col-md-4" v-on:click="onReportMemberNameList">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Member Name List</h3>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <blockquote>
                    <p>Menampilkan detail membership</p>
                  </blockquote>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- /.box -->
            </div>
          </div>
        </div>  
        <div v-bind:class="{ active: tabActive == TAB_LOYALTY }" class="tab-pane" id="tab_3">
          <div class="box no-border">
            <div class="col-md-4" v-on:click="onReportLoyaltySummaryDaily">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Loyaty Per Hari</h3>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <blockquote>
                    <p>Menampilkan total loyalty per hari</p>
                  </blockquote>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- /.box -->
            </div>
            <div class="col-md-4" v-on:click="onReportLoyaltyCustomerPointSummary">
              <div class="box box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Laporan Loyalty Customer Point</h3>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <blockquote>
                    <p>Menampilkan total point yang didapat customer</p>
                  </blockquote>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- /.box -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="modal fade" id="modal-view-file" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="height:500px;padding:5px;">
            <div id="reportViewer" style="width:100%;height:100%;" class="row" v-if="viewTypeReport == VIEW_REPORT">
              <iframe id="viewer" style="width:100%;height:100%;border:1px;"></iframe>
            </div>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">Group By</label>
                        <div class="col-sm-8">
                          <select v-model="groupBy" class="form-control">
                            <option v-for="(row, i) in listGroupBy" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdf()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalRevenueReportParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewer" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                        <div class="form-group">
                          <label for="inputPaymentDateFromRevenue" class="col-sm-4 control-label">Payment Date (From)</label>
                          <div class="col-sm-8">
                            <div class="input-group">
                              <datepicker style="width:100%" name="inputPaymentDateFromRevenue" :value=reportRevenueParams.paymentDateFrom
                                          :format=DATE_FORMAT
                                          :input-attr="{ 'id': 'inputPaymentDateFromRevenue' }"
                                          :input-style="{ 'width': '100%' }"
                                          :after-picked="onPickedFromDate"></datepicker>
                              <span class="input-group-addon">
                                <i class="icon ion-calendar"></i>
                              </span>
                            </div>                          
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="inputPaymentDateToRevenue" class="col-sm-4 control-label">Payment Date (To)</label>
                          <div class="col-sm-8">
                            <div class="input-group">
                              <datepicker style="width:100%" name="inputPaymentDateToRevenue" :value=reportRevenueParams.paymentDateTo
                                          :format=DATE_FORMAT
                                          :input-attr="{ 'id': 'inputPaymentDateToRevenue' }"
                                          :input-style="{ 'width': '100%' }"
                                          :after-picked="onPickedToDate"></datepicker>
                              <span class="input-group-addon">
                                <i class="icon ion-calendar"></i>
                              </span>
                            </div>                          
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="inputBookingDateFromRevenue" class="col-sm-4 control-label">Booking Date (From)</label>
                          <div class="col-sm-8">
                            <div class="input-group">
                              <datepicker style="width:100%" name="inputBookingDateFromRevenue" :value=reportRevenueParams.bookingDateFrom
                                          :format=DATE_FORMAT
                                          :input-attr="{ 'id': 'inputBookingDateFromRevenue' }"
                                          :input-style="{ 'width': '100%' }"
                                          :after-picked="onPickedFromDate"></datepicker>
                              <span class="input-group-addon">
                                <i class="icon ion-calendar"></i>
                              </span>
                            </div>                          
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="inputBookingDateToRevenue" class="col-sm-4 control-label">Booking Date (To)</label>
                          <div class="col-sm-8">
                            <div class="input-group">
                              <datepicker style="width:100%" name="inputBookingDateToRevenue" :value=reportRevenueParams.bookingDateTo
                                          :format=DATE_FORMAT
                                          :input-attr="{ 'id': 'inputBookingDateToRevenue' }"
                                          :input-style="{ 'width': '100%' }"
                                          :after-picked="onPickedToDate"></datepicker>
                              <span class="input-group-addon">
                                <i class="icon ion-calendar"></i>
                              </span>
                            </div>                          
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="downloadRevenueReport()">Download</button>
          </div>
        </div>
      </div>
    </div>    

    <div class="modal fade" id="modalReportSalesPOSParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerPOS" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdfPOS()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalReportSalesPOSNetParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerPOSNet" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdfPOS()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>    

    <div class="modal fade" id="modalReportGoodsMovementParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerGoodsMovement" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">Product Category</label>
                        <div class="col-sm-8">
                          <select v-model="productCategoryId" class="form-control">
                            <option v-for="(row, i) in listProductCategory" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>                         
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdfGoodsMovement()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalReportLoyaltySummaryParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerLoyaltySummary" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalReportLoyaltyCustomerPointSummaryParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerLoyaltyCustomerPoint" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputOperator" class="col-sm-4 control-label">Operator</label>
                        <div class="col-sm-8">
                          <select v-model="operator" class="form-control" id="inputOperator">
                            <option v-for="(op, i) in operatorOptions" v-bind:key="i" v-bind:value="op.id">
                              {{ op.name }}
                            </option>
                          </select>                         
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValue" class="col-sm-4 control-label">Total Point</label>
                        <div class="col-sm-8">
                          <input type="number" v-model.number="totalpoint" class="form-control" id="inputValue" placeholder="Masukkan nilai numerik">                      
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalReportMembershipSummaryParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerMembershipSummary" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">Product Category</label>
                        <div class="col-sm-8">
                          <select v-model="productCategoryId" class="form-control">
                            <option v-for="(row, i) in listProductCategory" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>                         
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <!-- <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button> -->
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <!-- <button type="button" class="btn btn-primary" @click="onPrintPdfGoodsMovement()" v-if="viewTypeReport == VIEW_REPORT">Print</button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalReportMembershipDetailParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerMembershipDetail" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">Product Category</label>
                        <div class="col-sm-8">
                          <select v-model="productCategoryId" class="form-control">
                            <option v-for="(row, i) in listProductCategory" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>                         
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <!-- <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button> -->
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <!-- <button type="button" class="btn btn-primary" @click="onPrintPdfGoodsMovement()" v-if="viewTypeReport == VIEW_REPORT">Print</button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalReportProductSoldSummaryParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerProductSoldSummary" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="col-md-12">
                          <label for="comboCashier" class="col-sm-4 control-label">Cashier</label>
                          <div class="col-sm-8">
                            <select2 :id="'comboCashierSummary'" :options="listCashier" :value="cashierSelected" style="width: 100%;">
                            </select2> 
                          </div>
                        </div>
                      </div>               
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdfProductSoldSummary()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>  
   
    <div class="modal fade" id="modalReportProductSoldListParams" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="width:100%;height:600px;padding:5px;">
            <iframe id="viewerProductSoldList" style="width:100%;height:100%;" v-if="viewTypeReport == VIEW_REPORT"></iframe>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">Product Category</label>
                        <div class="col-sm-8">
                          <select v-model="productCategoryId" class="form-control">
                            <option v-for="(row, i) in listProductCategory" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>                         
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="col-md-12">
                          <label for="comboCashier" class="col-sm-4 control-label">Cashier</label>
                          <div class="col-sm-8">
                            <select2 :id="'comboCashier'" :options="listCashier" :value="cashierSelected" style="width: 100%;">
                            </select2> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onDownloadXls()" v-if="viewTypeReport == VIEW_PARAMS">Download as Excel</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdfGoodsMovement()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>

  </div>  
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'
import moment from 'moment'
import select2 from '../../components/widgets/Select2'

const MODE_NONE = 'none'
const VIEW_PARAMS = 'reportParams'
const VIEW_REPORT = 'reportView'

const RPT_TYPE_SALES_POS = 'report-sales-pos'
const RPT_TYPE_SALES_POS_NET = 'report-sales-pos-net'
const RPT_TYPE_GOODS_MOVEMENT = 'report-goods-movement'
const RPT_TYPE_MEMBERSHIP_SUMMARY = 'report-membership-summary'
const RPT_TYPE_MEMBER_NAME_LIST = 'report-membership-detail'
const RPT_TYPE_PRODUCT_SOLD_SUMMARY = 'report-product-sold-summary'
const RPT_TYPE_PRODUCT_SOLD_LIST = 'report-product-sold-list'
const RPT_TYPE_LOYALTY_SUMMARY_LIST = 'report-loyalty-summary-list'
const RPT_TYPE_LOYALTY_CUSTOMER_POINT_LIST = 'report-loyalty-customer-point-list'

const TAB_TICKETING = 'tabTicketing'
const TAB_MEMBERSHIP = 'tabMembership'
const TAB_LOYALTY = 'tabLoyalty'

export default {
  name: 'Report',
  components: {
    datepicker, select2
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_SQL: config.dateTimeFormatSql,
      MODE_NONE: MODE_NONE,
      VIEW_PARAMS: VIEW_PARAMS,
      VIEW_REPORT: VIEW_REPORT,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      formRepParams: {
        fromDate: '',
        toDate: ''
      },
      reportRevenueParams: {
        paymentDateFrom: '',
        paymentDateTo: '',
        bookingDateFrom: '',
        bookingDateTo: ''
      },
      operatorOptions: [
        { id: '=', name: '= (Sama dengan)' },
        { id: '>', name: '> (Lebih besar)' },
        { id: '<', name: '< (Lebih kecil)' },
        { id: '>=', name: '>= (Lebih besar atau sama)' },
        { id: '<=', name: '<= (Lebih kecil atau sama)' }
      ],
      viewTypeReport: VIEW_PARAMS,
      viewMode: MODE_NONE,
      projectSelectedDetail: undefined,
      listProductCategory: null,
      productCategoryId: '',
      productCategoryName: '',
      listCashier: null,
      listCashierTemp: null,
      cashierSelected: [],
      reportType: '',
      operator: '>',
      totalpoint: 5,
      listGroupBy: [{
        id: 1,
        name: 'Booking Date'
      },
      {
        id: 2,
        name: 'Process Date'
      },
      {
        id: 3,
        name: 'Summary'
      }],
      groupBy: 1,
      tabActive: '',
      TAB_TICKETING: TAB_TICKETING,
      TAB_MEMBERSHIP: TAB_MEMBERSHIP,
      TAB_LOYALTY: TAB_LOYALTY
    }
  },
  computed: {
  },
  created() {
    this.viewTypeReport = VIEW_PARAMS
    this.tabActive = TAB_TICKETING
  },
  mounted() {
    this.$root.$on('generateReport', (projectIds, projectSelectedDetail) => {
      if (projectSelectedDetail) {
        this.projectSelectedDetail = projectSelectedDetail
      }
    })
  },
  methods: {
    onReport() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this
      console.log(this.projectSelectedDetail)
      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modal-view-file').modal('show')
      this.viewTypeReport = VIEW_PARAMS
    },
    onPickedFromDate(date) {
      this.formRepParams.fromDate = date
    },
    onPickedToDate(date) {
      this.formRepParams.toDate = date
    },
    onPreviewPdf() {
      var validFrom = ''
      var validTo = ''
      var paramFrom = ''
      var paramTo = ''
      var params = ''
      var arrCashierSelected = $('#comboCashier').val()
      var arrCashierSummarySelected = $('#comboCashierSummary').val()
      var lstCashierSelected = []

      if (this.reportType === RPT_TYPE_SALES_POS) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo
          // params = 'mainProjectId=7;projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo

          this.viewTypeReport = VIEW_REPORT
          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_SalesPOS.pdf&paramsReport=' + params, null, 'blob')
            .then(response => {
              const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
              const objUrl = window.URL.createObjectURL(pdfBlob)
              const iframe = window.$('#viewerPOS')[0]
              window.$('#modalReportSalesPOSParams').modal({
                backdrop: 'static',
                keyboard: false
              })
              iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
              iframe.onload = () => {
                setTimeout(() => {
                  window.URL.revokeObjectURL(objUrl)
                }, 2000)
              }
            })
        }
      } else if (this.reportType === RPT_TYPE_SALES_POS_NET) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          params = 'projectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';fromDate=' + paramFrom + ';toDate=' + paramTo

          this.viewTypeReport = VIEW_REPORT
          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_SalesPOSNet.pdf&paramsReport=' + params, null, 'blob')
            .then(response => {
              const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
              const objUrl = window.URL.createObjectURL(pdfBlob)
              const iframe = window.$('#viewerPOSNet')[0]
              window.$('#modalReportSalesPOSNetParams').modal({
                backdrop: 'static',
                keyboard: false
              })
              iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
              iframe.onload = () => {
                setTimeout(() => {
                  window.URL.revokeObjectURL(objUrl)
                }, 2000)
              }
            })
        }
      } else if (this.reportType === RPT_TYPE_GOODS_MOVEMENT) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo + ';mainProductCategory=' + this.productCategoryId

          this.viewTypeReport = VIEW_REPORT
          api.request('Sales', 'get', '/api/GoodsMovement/Reports?fileReport=goods_movement_perproduct.pdf&paramsReport=' + params, null, 'blob')
            .then(response => {
              const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
              const objUrl = window.URL.createObjectURL(pdfBlob)
              const iframe = window.$('#viewerGoodsMovement')[0]
              window.$('#modalReportGoodsMovementParams').modal({
                backdrop: 'static',
                keyboard: false
              })
              iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
              iframe.onload = () => {
                setTimeout(() => {
                  window.URL.revokeObjectURL(objUrl)
                }, 2000)
              }
            })
        }
      } else if (this.reportType === RPT_TYPE_MEMBERSHIP_SUMMARY) {
        params = 'projectId=' + this.$store.state.userInfo.projects[0]

        this.viewTypeReport = VIEW_REPORT
        api.request('Guest', 'get', '/api/Membership/Report/Summary?fileReport=eMembers_MembershipTypeAndStatusSummary.pdf&paramsReport=' + params, null, 'blob')
          .then(response => {
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
            const objUrl = window.URL.createObjectURL(pdfBlob)
            const iframe = window.$('#viewerMembershipSummary')[0]
            window.$('#modalReportMembershipSummaryParams').modal({
              backdrop: 'static',
              keyboard: false
            })
            iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
            iframe.onload = () => {
              setTimeout(() => {
                window.URL.revokeObjectURL(objUrl)
              }, 2000)
            }
          })
      } else if (this.reportType === RPT_TYPE_LOYALTY_SUMMARY_LIST) {
        // params = 'projectId=' + this.$store.state.userInfo.projects[0]
        validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
        validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
        paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
        paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')

        params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo
        this.viewTypeReport = VIEW_REPORT
        api.request('Guest', 'get', '/api/Membership/Report/Summary?fileReport=voucher_header_processdate.pdf&paramsReport=' + params, null, 'blob')
          .then(response => {
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
            const objUrl = window.URL.createObjectURL(pdfBlob)
            const iframe = window.$('#viewerLoyaltySummary')[0]

            window.$('#modalReportLoyaltySummaryParams').modal({
              backdrop: 'static',
              keyboard: false
            })
            iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
            iframe.onload = () => {
              setTimeout(() => {
                window.URL.revokeObjectURL(objUrl)
              }, 2000)
            }
          })
      } else if (this.reportType === RPT_TYPE_LOYALTY_CUSTOMER_POINT_LIST) {
        // params = 'projectId=' + this.$store.state.userInfo.projects[0]
        let validUntil = new Date()
        paramTo = utilities.DisplayDate(validUntil, 'yyyy-MM-dd')

        params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateEnd=' + paramTo + ';mainTotalPoint=' + this.operator + this.totalpoint
        this.viewTypeReport = VIEW_REPORT
        api.request('Guest', 'get', '/api/Membership/Report/Summary?fileReport=customer_point_summary.pdf&paramsReport=' + params, null, 'blob')
          .then(response => {
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
            const objUrl = window.URL.createObjectURL(pdfBlob)
            const iframe = window.$('#viewerLoyaltyCustomerPoint')[0]
            window.$('#modalReportLoyaltyCustomerPointSummaryParams').modal({
              backdrop: 'static',
              keyboard: false
            })
            iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
            iframe.onload = () => {
              setTimeout(() => {
                window.URL.revokeObjectURL(objUrl)
              }, 2000)
            }
          })
      } else if (this.reportType === RPT_TYPE_MEMBER_NAME_LIST) {
        params = 'projectId=' + this.$store.state.userInfo.projects[0]

        this.viewTypeReport = VIEW_REPORT
        api.request('Guest', 'get', '/api/Membership/Report/Detail?fileReport=eMembers_MemberNameList.pdf&paramsReport=' + params, null, 'blob')
          .then(response => {
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
            const objUrl = window.URL.createObjectURL(pdfBlob)
            const iframe = window.$('#viewerMembershipDetail')[0]
            window.$('#modalReportMembershipDetailParams').modal({
              backdrop: 'static',
              keyboard: false
            })
            iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
            iframe.onload = () => {
              setTimeout(() => {
                window.URL.revokeObjectURL(objUrl)
              }, 2000)
            }
          })
      } else if (this.reportType === RPT_TYPE_PRODUCT_SOLD_SUMMARY) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          if (arrCashierSummarySelected) {
            arrCashierSummarySelected.forEach(element => {
              lstCashierSelected.push(JSON.parse(element))
            })
          }

          params = 'projectId=' + this.$store.state.userInfo.projects[0] +
                  ';projectName=' + this.projectSelectedDetail.name +
                  ';fromDate=' + paramFrom +
                  ';toDate=' + paramTo +
                  ';cashierId=' + lstCashierSelected.join()

          this.viewTypeReport = VIEW_REPORT

          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_ProductSoldSummary.pdf&paramsReport=' + params, null, 'blob')
            .then(response => {
              const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
              const objUrl = window.URL.createObjectURL(pdfBlob)
              const iframe = window.$('#viewerProductSoldSummary')[0]

              window.$('#modalReportProductSoldSummaryParams').modal({
                backdrop: 'static',
                keyboard: false
              })
              iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
              iframe.onload = () => {
                setTimeout(() => {
                  window.URL.revokeObjectURL(objUrl)
                }, 2000)
              }
            })
          .catch(error => {
            console.error('Gagal memuat PDF:', error)
          })
        }
      } else if (this.reportType === RPT_TYPE_PRODUCT_SOLD_LIST) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          if (arrCashierSelected) {
            arrCashierSelected.forEach(element => {
              lstCashierSelected.push(JSON.parse(element))
            })
          }
          this.productCategoryName = this.listProductCategory.find(item => item.id === this.productCategoryId).name
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';mainProjectName=' + this.projectSelectedDetail.name + ';mainStartDate=' + paramFrom + ';mainEndDate=' + paramTo + ';mainCategoryId=' + this.productCategoryId + ';mainCategoryName=' + this.productCategoryName + ';mainCashierId=' + lstCashierSelected.join()

          this.viewTypeReport = VIEW_REPORT
          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_ProductSoldList.pdf&paramsReport=' + params, null, 'blob')
            .then(response => {
              const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
              const objUrl = window.URL.createObjectURL(pdfBlob)
              const iframe = window.$('#viewerProductSoldList')[0]

              window.$('#modalReportProductSoldListParams').modal({
                backdrop: 'static',
                keyboard: false
              })
              iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
              iframe.onload = () => {
                setTimeout(() => {
                  window.URL.revokeObjectURL(objUrl)
                }, 2000)
              }
            })
            .catch(error => {
              console.error('Gagal memuat PDF:', error)
            })
        }
      } else {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'dd/MM/yyyy')
          paramTo = utilities.DisplayDate(validTo, 'dd/MM/yyyy')
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo
          this.viewTypeReport = VIEW_REPORT
          if (this.groupBy === 1) {
            api.request('Payment', 'get', '/api/Payment/Reports?fileReport=payment_header.pdf&paramsReport=' + params, null, 'blob')
              .then(response => {
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                const objUrl = window.URL.createObjectURL(pdfBlob)
                const iframe = window.$('#viewer')[0]

                window.$('#modal-view-file').modal({
                  backdrop: 'static',
                  keyboard: false
                })
                iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
                iframe.onload = () => {
                  setTimeout(() => {
                    window.URL.revokeObjectURL(objUrl)
                  }, 2000)
                }
              }).catch(error => {
                console.error('Gagal memuat PDF:', error)
              })
          } else if (this.groupBy === 2) {
            api.request('Payment', 'get', '/api/Payment/Reports?fileReport=payment_header_processdate.pdf&paramsReport=' + params, null, 'blob')
              .then(response => {
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                const objUrl = window.URL.createObjectURL(pdfBlob)
                const iframe = window.$('#viewer')[0]
                window.$('#modal-view-file').modal({
                  backdrop: 'static',
                  keyboard: false
                })

                iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
                iframe.onload = () => {
                  setTimeout(() => {
                    window.URL.revokeObjectURL(objUrl)
                  }, 2000)
                }
              }).catch(error => {
                console.error('Gagal memuat PDF:', error)
              })
          } else if (this.groupBy === 3) {
            api.request('Payment', 'get', '/api/Payment/Reports?fileReport=summary_payment.pdf&paramsReport=' + params, null, 'blob')
              .then(response => {
                const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                const objUrl = window.URL.createObjectURL(pdfBlob)
                const iframe = window.$('#viewer')[0]

                window.$('#modal-view-file').modal({
                  backdrop: 'static',
                  keyboard: false
                })

                iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
                iframe.onload = () => {
                  setTimeout(() => {
                    window.URL.revokeObjectURL(objUrl)
                  }, 2000)
                }
              }).catch(error => {
                console.error('Gagal memuat PDF:', error)
              })
          }
        }
      }
      window.$('#modal-view-file').modal('hide')
    },
    onPrintPdf() {
      const iframe = window.$('#viewer')[0]
      iframe.focus()
      iframe.contentWindow.print()
    },
    onPrintPdfPOS() {
      const iframe = window.$('#viewerPOS')[0]
      iframe.focus()
      iframe.contentWindow.print()
    },
    onPrintPdfGoodsMovement() {
      const iframe = window.$('#viewerGoodsMovement')[0]
      iframe.focus()
      iframe.contentWindow.print()
    },
    onRevenueReport() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this
      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modalRevenueReportParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
    },
    downloadRevenueReport() {
      let queryString = ''
      let paymentDateFrom = ''
      let paymentDateTo = ''
      let bookingDateFrom = ''
      let bookingDateTo = ''

      if ($('#inputPaymentDateFromRevenue').val() !== '') {
        this.reportRevenueParams.paymentDateFrom = $('#inputPaymentDateFromRevenue').val()
        paymentDateFrom = moment(this.reportRevenueParams.paymentDateFrom, this.DATE_FORMAT)
        paymentDateFrom = moment(paymentDateFrom).format(this.DATE_FORMAT_SQL) + ' 00:00:00'
        paymentDateFrom = this.convertToUtcTime(paymentDateFrom, this.DATETIME_FORMAT_SQL)
      }
      if ($('#inputPaymentDateToRevenue').val() !== '') {
        this.reportRevenueParams.paymentDateTo = $('#inputPaymentDateToRevenue').val()
        paymentDateTo = moment(this.reportRevenueParams.paymentDateTo, this.DATE_FORMAT)
        paymentDateTo = moment(paymentDateTo).format(this.DATE_FORMAT_SQL) + ' 00:00:00'
        paymentDateTo = this.convertToUtcTime(paymentDateTo, this.DATETIME_FORMAT_SQL)
      }
      if ($('#inputBookingDateFromRevenue').val() !== '') {
        this.reportRevenueParams.bookingDateFrom = $('#inputBookingDateFromRevenue').val()
        bookingDateFrom = moment(this.reportRevenueParams.bookingDateFrom, this.DATE_FORMAT)
        bookingDateFrom = moment(bookingDateFrom).format(this.DATE_FORMAT_SQL)
      }
      if ($('#inputBookingDateToRevenue').val() !== '') {
        this.reportRevenueParams.bookingDateTo = $('#inputBookingDateToRevenue').val()
        bookingDateTo = moment(this.reportRevenueParams.bookingDateTo, this.DATE_FORMAT)
        bookingDateTo = moment(bookingDateTo).format(this.DATE_FORMAT_SQL)
      }

      paymentDateFrom = paymentDateFrom === '' ? '1900-01-01 00:00:00' : paymentDateFrom
      paymentDateTo = paymentDateTo === '' ? '9999-12-31 00:00:00' : paymentDateTo
      bookingDateFrom = bookingDateFrom === '' ? '1900-01-01' : bookingDateFrom
      bookingDateTo = bookingDateTo === '' ? '9999-12-31' : bookingDateTo
      queryString = '?PaymentDateFrom=' + paymentDateFrom + '&PaymentDateTo=' + paymentDateTo + '&BookingDateFrom=' + bookingDateFrom + '&BookingDateTo=' + bookingDateTo + '&ProjectId=' + this.$store.state.userInfo.projects[0]

      api.request('Payment', 'get', '/api/Payment/Reports/Revenue' + queryString, null, 'blob')
        .then(response => {
          window.$('#modalRevenueReportParams').modal('hide')
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'eMembers-LaporanPenerimaan.xls')
          document.body.appendChild(link)
          link.click()
        })
    },
    onReportSalesPOS() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this
      // console.log(this.projectSelectedDetail)
      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modalReportSalesPOSParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_SALES_POS
    },
    onReportSalesPOSNet() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this
      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modalReportSalesPOSNetParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_SALES_POS_NET
    },
    onReportGoodsMovement() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this
      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      this.getProductCategory()

      window.$('#modalReportGoodsMovementParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_GOODS_MOVEMENT
    },
    getProductCategory() {
      api
        .request('Sales', 'get', '/api/ProductCategory/InquiryAll', null)
        .then(response => {
          var dataCategory = [{'id': 0, 'name': 'All Category', 'productTypeId': 0, 'flowTypeSAP': '', 'incomeAccount': ''}]
          var data = response.data
          dataCategory = dataCategory.concat(data.entity)
          this.listProductCategory = dataCategory
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCashier() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      var arrCashier = []

      api
        .request('POS', 'get', '/api/POS/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(async response => {
          this.listDataTemp = response.data.entity
          this.total = response.data.totalRows
          this.totalPages = response.data.totalPages

          // Populate customer and bill to
          for (let x = 0; x < this.listDataTemp.length; x++) {
            var posDetail = await api
              .request('POS', 'get', '/api/POS/GetDetail?Id=' + this.listDataTemp[x].id, null)
              .then(response => {
                return response.data.entity
              })
            for (let i = 0; i < posDetail.cashier.length; i++) {
              // Get cashier id
              arrCashier.push(posDetail.cashier[i].cashierId)
            }
            // posDetail.cashier.forEach(element => {
            //   arrCashier.push(element.cashierId)
            // })
          }
          console.log('arrCashier', arrCashier)
          var arrCashierUnique = arrCashier.filter(function(item, index) {
            return arrCashier.indexOf(item) >= index
          })
          arrCashier = arrCashierUnique
          // this.cashierSelected = arrCashier

          var arrUser = []
          if (arrCashier.length > 0) {
            arrUser = 'Id IN (' + arrCashier.join(',') + ')'
          } else {
            arrUser = ''
          }
          // Get cashier list
          api
            .request('Account', 'get', '/api/Account/Inquiry?WhereClause=' + arrUser +
                                    '&&PageSize=1000&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Name', null)
            .then(response => {
              var data = response.data
              this.listCashierTemp = data.entity
              this.listCashier = []
              this.listCashierTemp.forEach(item => {
                let objCashier = {
                  id: item.id,
                  text: item.name
                }
                this.listCashier.push(objCashier)
              })
            })
            .catch(error => {
              var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            })
        })
    },
    onDownloadXls() {
      var validFrom = ''
      var validTo = ''
      var paramFrom = ''
      var paramTo = ''
      var params = ''
      var lstCashierSelected = []
      var arrCashierSelected = $('#comboCashier').val()
      var arrCashierSummarySelected = $('#comboCashierSummary').val()

      if (this.reportType === RPT_TYPE_SALES_POS) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo

          this.viewTypeReport = VIEW_REPORT

          window.$('#modalReportSalesPOSParams').modal('hide')

          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_SalesPOS.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-PoS.xls')
              document.body.appendChild(link)
              link.click()
            })
        }

        return
      }
      if (this.reportType === RPT_TYPE_SALES_POS_NET) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          params = 'projectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';fromDate=' + paramFrom + ';toDate=' + paramTo

          this.viewTypeReport = VIEW_REPORT

          window.$('#modalReportSalesPOSParams').modal('hide')

          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_SalesPOSNet.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-PoS-Net.xls')
              document.body.appendChild(link)
              link.click()
            })
        }

        return
      }
      if (this.reportType === RPT_TYPE_GOODS_MOVEMENT) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo + ';mainProductCategory=' + this.productCategoryId

          this.viewTypeReport = VIEW_REPORT

          window.$('#modalReportGoodsMovementParams').modal('hide')

          api.request('Sales', 'get', '/api/GoodsMovement/Reports?fileReport=goods_movement_perproduct.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-Stock.xls')
              document.body.appendChild(link)
              link.click()
            })
        }

        return
      }
      if (this.reportType === RPT_TYPE_PRODUCT_SOLD_SUMMARY) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          if (arrCashierSummarySelected) {
            arrCashierSummarySelected.forEach(element => {
              lstCashierSelected.push(JSON.parse(element))
            })
          }
          params = 'projectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';fromDate=' + paramFrom + ';toDate=' + paramTo + ';cashierId=' + lstCashierSelected.join()

          this.viewTypeReport = VIEW_REPORT
          window.$('#modalReportProductSoldSummaryParams').modal('hide')
          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_ProductSoldSummary.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-Product-Sold-Summary.xls')
              document.body.appendChild(link)
              link.click()
            })
        }

        return
      }
      if (this.reportType === RPT_TYPE_PRODUCT_SOLD_LIST) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
          if (arrCashierSelected) {
            arrCashierSelected.forEach(element => {
              lstCashierSelected.push(JSON.parse(element))
            })
          }
          this.productCategoryName = this.listProductCategory.find(item => item.id === this.productCategoryId).name
          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';mainProjectName=' + this.projectSelectedDetail.name + ';mainStartDate=' + paramFrom + ';mainEndDate=' + paramTo + ';mainCategoryId=' + this.productCategoryId + ';mainCategoryName=' + this.productCategoryName + ';mainCashierId=' + lstCashierSelected.join()

          this.viewTypeReport = VIEW_REPORT
          window.$('#modalReportProductSoldListParams').modal('hide')
          api.request('Sales', 'get', '/api/SalesOrder/Reports?fileReport=eMembers_ProductSoldList.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-Product-Sold-List.xls')
              document.body.appendChild(link)
              link.click()
            })
          return
        }
      }
      if (this.reportType === RPT_TYPE_LOYALTY_CUSTOMER_POINT_LIST) {
        if (this.operator !== '' && this.totalpoint !== '') {
          let validUntil = new Date()
          paramTo = utilities.DisplayDate(validUntil, 'yyyy-MM-dd')

          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateEnd=' + paramTo + ';mainTotalPoint=' + this.operator + this.totalpoint
          this.viewTypeReport = VIEW_REPORT
          window.$('#modalReportLoyaltyCustomerPointSummaryParams').modal('hide')
          api.request('Guest', 'get', '/api/Membership/Report/Summary?fileReport=customer_point_summary.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'customer-point-summary.xls')
              document.body.appendChild(link)
              link.click()
            })
          return
        }
      }
      if (this.reportType === RPT_TYPE_LOYALTY_SUMMARY_LIST) {
        if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
          validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
          validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
          paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
          paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')

          params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo
          this.viewTypeReport = VIEW_REPORT
          window.$('#modalReportLoyaltySummaryParams').modal('hide')
          api.request('Guest', 'get', '/api/Membership/Report/Summary?fileReport=voucher_header_processdate.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'summary-voucher-redeem-daily.xls')
              document.body.appendChild(link)
              link.click()
            })
          return
        }
      }
      if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
        validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
        validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
        paramFrom = utilities.DisplayDate(validFrom, 'dd/MM/yyyy')
        paramTo = utilities.DisplayDate(validTo, 'dd/MM/yyyy')
        params = 'mainProjectId=' + this.$store.state.userInfo.projects[0] + ';projectName=' + this.projectSelectedDetail.name + ';mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo
        this.viewTypeReport = VIEW_REPORT

        window.$('#modal-view-file').modal('hide')
        if (this.groupBy === 1) {
          api.request('Payment', 'get', '/api/Payment/Reports?fileReport=payment_header.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-Penerimaan-OP.xls')
              document.body.appendChild(link)
              link.click()
            })
        } else if (this.groupBy === 2) {
          api.request('Payment', 'get', '/api/Payment/Reports?fileReport=payment_header_processdate.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-Penerimaan-online.xls')
              document.body.appendChild(link)
              link.click()
            })
        } else if (this.groupBy === 3) {
          api.request('Payment', 'get', '/api/Payment/Reports?fileReport=summary_payment.xls&paramsReport=' + params, null, 'blob')
            .then(response => {
              const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }))

              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Laporan-Summary-Penerimaan-Online.xls')
              document.body.appendChild(link)
              link.click()
            })
        }
      }
    },
    onReportLoyaltySummaryDaily() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this

      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modalReportLoyaltySummaryParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_LOYALTY_SUMMARY_LIST
    },
    onReportLoyaltyCustomerPointSummary() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this

      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modalReportLoyaltyCustomerPointSummaryParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_LOYALTY_CUSTOMER_POINT_LIST
    },
    onReportMembershipTypeSummary() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this

      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modal-view-file').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_MEMBERSHIP_SUMMARY
    },
    onReportMemberNameList() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this

      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      window.$('#modal-view-file').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_MEMBER_NAME_LIST
    },
    onReportProductSoldList() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this

      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      this.getProductCategory()
      this.getCashier()
      window.$('#modalReportProductSoldListParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_PRODUCT_SOLD_LIST
    },
    onReportProductSoldSUmmary() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose one project that you are authorized', 'info')
        return
      }

      let me = this

      if (this.projectSelectedDetail === undefined) {
        api.request('Account', 'get', '/api/Project/GetDetail?Id=' + this.$store.state.userInfo.projects[0])
          .then(response => {
            me.projectSelectedDetail = response.data.entity
          })
      }
      this.getCashier()
      window.$('#modalReportProductSoldSummaryParams').modal('show')
      this.viewTypeReport = VIEW_PARAMS
      this.reportType = RPT_TYPE_PRODUCT_SOLD_SUMMARY
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Report.vue?4edd4ae6